import {
  NAV_CUSTOMER_CARD_SECTIONS,
  resolveNavCardValue,
} from '../../lib/accountCreationNavPush';

type Props = {
  defaults: Record<string, string>;
  overrides: Record<string, string>;
  onChange: (field: string, value: string) => void;
  disabled?: boolean;
};

/**
 * Detail-page editor: every NAV CustomerCard field grouped by spreadsheet category.
 * Display = override if set, else auto-mapped default from form/finance.
 */
export function AccountCreationNavCardPanel({
  defaults,
  overrides,
  onChange,
  disabled,
}: Props) {
  return (
    <section className="af-form__section af-official-use__block af-nav-card-panel">
      <h3 className="af-form__section-title">NAV CustomerCard</h3>
      <p className="af-settings-field__hint" style={{ marginBottom: 12 }}>
        Fields below are sent to NAV on Push. Values prefilled from this application can be
        edited here; empty fields are skipped on create.
      </p>
      {NAV_CUSTOMER_CARD_SECTIONS.map((section) => (
        <div key={section.id} className="af-nav-card-panel__section">
          <h4 className="af-nav-card-panel__heading">
            {section.title}
            {section.subtitle && section.subtitle !== section.title ? (
              <span className="af-nav-card-panel__subtitle"> · {section.subtitle}</span>
            ) : null}
          </h4>
          <div className="af-form__grid af-form__grid--cols-2">
            {section.fields.map((field) => {
              const value = resolveNavCardValue(field, overrides, defaults);
              const isOverridden = Object.prototype.hasOwnProperty.call(overrides, field);
              return (
                <label
                  key={field}
                  className={`af-form__field${isOverridden ? ' af-nav-card-panel__field--override' : ''}`}
                >
                  <span>{field}</span>
                  <input
                    type="text"
                    value={value}
                    onChange={(e) => onChange(field, e.target.value)}
                    disabled={disabled}
                    autoComplete="off"
                    spellCheck={false}
                  />
                </label>
              );
            })}
          </div>
        </div>
      ))}
    </section>
  );
}
